'use client';
import { Textfield as BaseTextfield } from '@lichtblick/photon/molecules/textfield/textfield';

import { withValidation } from './Form.helpers';

export const Textfield = withValidation(BaseTextfield);
